'use client'

import React, { createContext } from "react"

import { Translations } from "@/i18n/translations"

const TranslationsContext = createContext<Translations | null>(null)

export default function TranslationsProvider({
  translations,
  children,
}: {
  translations: Translations
  children: React.ReactNode
}) {
  return (
    <TranslationsContext.Provider value={translations}>
      {children}
    </TranslationsContext.Provider>
  )
}

export function useTranslations() {
  const translations = React.useContext(TranslationsContext)

  if (!translations) {
    throw new Error('useTranslations hook must be used within TranslationsProvider')
  }

  return translations
}